export default "__VITE_ASSET__0f9e51d1__"